import flowplayer from './flowplayer.js';
import swfFile from './flowplayer.swf';

export default function () {
  let container = document.getElementById('player');

  flowplayer(function (api, root) {
    api.bind('load', function () {
      document.querySelector('.video-preview').style.display = 'none';
    });
  });

  flowplayer(container, {
    swf: swfFile,
    key: '$129188077864423',
    rtmp: 'rtmp://s3o6pq8gawbiw.cloudfront.net/cfx/st',
    ratio: 3/4,   // video with 4:3 aspect ratio
    splash: true,  // a splash setup
    embed: false,
    chromecast: false,
    clip: {
      sources: [
        { type: 'video/mp4', src: container.dataset.src }
      ]
    }
  });
}
